
const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#eee"; // 图表splitLine的颜色，参考SOC-功率跟踪分析曲线
const textColor = "#999"; // 图表文字的颜色，参考SOC-功率跟踪分析曲线
// 已移除 ringSymbol，不再需要柱状图顶部的小圆圈
const $str = window.$str;

export function getChartOption(chartData = []) {
  const { yMin, yMax } = getYaxisRange(chartData);
  const option = {
    // color: chartColors,
    grid: {
      left: "1%",
      right: "1%",
      top: "15%",
      bottom: "10%",
      containLabel: true
    },
    title: {
      show: false,
      textStyle: {
        fontFamily: 'HarmonyOS Sans SC', // 参考SOC-功率跟踪分析曲线，使用HarmonyOS字体
        // color: "#c3c3c3",
        color: textColor,
        fontSize: 16
      },
      text: $str.getKey('收益管理/收益统计图'),
      x: "0%"
    },
    xAxis: {
        type: 'category',
        nameTextStyle: {
          color: textColor
        },
        axisLabel: {
          color: textColor,
        },
        axisTick: {
          show: false // 参考SOC-功率跟踪分析曲线，隐藏刻度
        },
        axisLine: { // 坐标轴轴线的配置
          show: false, // 参考SOC-功率跟踪分析曲线，隐藏轴线
          lineStyle: {
            color: lineColor
          }
        },
        data: chartData.map(it => it.time),
    },
    yAxis: {
        type: 'value',
        name: $str.getKey('收益管理/收益') + "(" + $str.getKey('收益管理/元') + ")",
        nameTextStyle: {
          fontFamily: 'HarmonyOS Sans SC', // 参考SOC-功率跟踪分析曲线，使用HarmonyOS字体
          color: textColor,
          align: 'center',
          padding: [0, 0, 0, 0] // 参考SOC-功率跟踪分析曲线
        },
        // nameLocation: 'end',
        max: yMax,
        min: yMin,
        splitLine: {
          lineStyle: {
            color: lineColor, // 使用 #eee
            type: 'dashed' // 保持虚线样式
          }
        },
        axisLabel: {
          color: textColor, // 使用 #999
          formatter: '{value}' // 参考SOC-功率跟踪分析曲线的格式
        },
        axisLine: {
          show: false, // 参考SOC-功率跟踪分析曲线，隐藏轴线
          lineStyle: {
            color: lineColor
          }
        },
        splitNumber: 6 // 设置Y轴默认分割5个段
    },
    series: createSeries(chartData),
    legend: {
      show: false,
      top: "10%",
      right: "0%", // 10
      icon: "circle",
      itemWidth: 8,
      width: "100%",
      textStyle: {
          fontFamily: 'HarmonyOS Sans SC', // 参考SOC-功率跟踪分析曲线，使用HarmonyOS字体
          color: textColor,
          fontSize: 14,
      }
    },
    tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' }, // 鼠标指示器-辅助线，对所有坐标系生效
      label: {
        backgroundColor: '#777' // 鼠标指示器-坐标文字提示的颜色
      }
    },
    dataZoom: [
      {
        show: true,
        type: 'inside',
      }
    ],
  }

  return option
}


function getYaxisRange(chartData) {
  const result = {
    yMin: 0, 
    yMax: 1000, 
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    result.yMax = undefined;
    result.yMin = undefined;
  }
  return result;
}


function createSeries(chartData = []) {
  const series = [];
  // 移除柱状图顶部的小圆圈（pictorialBar）
  // const item1 = {
  //   type: "pictorialBar",
  //   symbol: ringSymbol,
  //     // "image://data:image/png;base64,...",
  //     symbolSize: [20, 20],
  //     symbolOffset: [0, -8],
  //     z: 12,
  //     tooltip: {
  //       show: false
  //     },
  //     data: chartData.map(it => {
  //       return {
  //         value: it.value,
  //         symbolPosition: "end"
  //       }
  //     }),
  //   };
  //   series.push(item1);

  const item2 = {
    name: $str.getKey('收益管理/收益') + '(' + $str.getKey('收益管理/元') + ')',
    type: "bar",
    barMaxWidth: 6,

    itemStyle: {
      normal: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: `#DEF8B3` // 浅绿色，参考截图中的进度条颜色
            },
            {
              offset: 0.5,
              color: `#B8E5D6` // 浅蓝色，参考截图中的进度条颜色
            },
            {
              offset: 1,
              color: `#8DD3F5` // 浅蓝色透明，保持渐变效果
            }
          ],
          globalCoord: false
        },
        barBorderRadius: [30, 30, 0, 0],
        shadowColor: "rgba(141, 211, 245, 0.3)", // 调整为浅蓝色阴影，与柱状图颜色协调
        shadowBlur: 4
      }
    },
    data: chartData.map(it => it.value),
  }

  series.push(item2);

  return series;
}



function createTooltip(config={}) {
  return {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    // tips 背景色改为与主页面一致
    backgroundColor: '#ffffff',
    borderColor: 'rgba(15, 23, 42, 0.06)',
    // 鼠标移走后立即隐藏
    hideDelay: 0,
    enterable: false,
    formatter(params) {
      if (params.length > 0) {
        const firstItem = params[0];
        const time = firstItem.name;
        const incomeValue = firstItem.value ?? '--';
        const itemColor = '#8DD3F5'; // 浅蓝色，与柱状图颜色一致
        return /* html */`
          <div class="chart-tooltip__time">${$str.getKey('收益管理/时间')}: ${time}</div>
          
          <div class="chart-tooltip__items-container">
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${itemColor}"></div>
              <div class="chart-tooltip__series-name">${$str.getKey('收益管理/收益')}: </div>
              <div class="chart-tooltip__value">${incomeValue} ${$str.getKey('收益管理/元')}</div>
            </div>
          </div>  
        `
      }
      return `<div class="chart-tooltip__items-container">${$str.getKey('全局/暂无数据')}</div>`
    }
  }
}


